import { useState } from "react";
import * as Popover from "@radix-ui/react-popover";
import { Calendar, Clock } from "lucide-react";

interface ActivityItem {
    id: string;
    title: string;
    time: string;
}

// Header calendar — placeholder for scheduled activities, mirrored from the
// original frontend's ActivityScheduleNotification.tsx. Activities feed will
// land when the cross-record /api/activities endpoint exists.
export function ActivityNotification() {
    const [open, setOpen] = useState(false);

    // Empty for now — populated via EventBus / API later.
    const activities: ActivityItem[] = [];

    return (
        <Popover.Root open={open} onOpenChange={setOpen}>
            <Popover.Trigger asChild>
                <button className="icon-btn" type="button" title="Scheduled activities" aria-label="Scheduled activities">
                    <Calendar size={16} />
                </button>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content className="notif-pane notif-pane--activity" align="end" sideOffset={6}>
                    <div className="notif-pane__header">
                        <span className="notif-pane__title">Scheduled Activities</span>
                    </div>

                    {activities.length === 0 ? (
                        <div className="notif-pane__empty">
                            <Calendar size={28} className="notif-pane__empty-icon" />
                            <span>No upcoming activities</span>
                        </div>
                    ) : (
                        <div className="notif-pane__list">
                            {activities.map((a) => (
                                <button key={a.id} type="button" className="notif-item">
                                    <span className="notif-item__icon notif-item__icon--info">
                                        <Clock size={14} />
                                    </span>
                                    <span className="notif-item__body">
                                        <span className="notif-item__subject">{a.title}</span>
                                        <span className="notif-item__time">{a.time}</span>
                                    </span>
                                </button>
                            ))}
                        </div>
                    )}
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
}
